import { getDateOnly } from "../helpers/utils/date.convert";

export function timeDiff(time1: string, time2: string, minutesInterval?: number) {
  if (!time1 || !time2) return "00:00";

  const [hours1, minutes1, seconds1] = time1.split(":").map(Number);
  const [hours2, minutes2, seconds2] = time2.split(":").map(Number);

  // Convert time values to total seconds
  const totalSeconds1 = hours1 * 3600 + minutes1 * 60 + (seconds1 ?? 0);
  let totalSeconds2 = hours2 * 3600 + minutes2 * 60 + (seconds2 ?? 0);

  if (minutesInterval && minutesInterval > 0) {
    const intervalSeconds = minutesInterval * 60;
    totalSeconds2 = totalSeconds2 - intervalSeconds;
  }

  // Calculate the time difference in seconds
  const differenceSeconds = Math.abs(totalSeconds1 - totalSeconds2);

  // Convert the difference back to HH:mm:ss format
  const hours = Math.floor(differenceSeconds / 3600);
  const minutes = Math.floor((differenceSeconds % 3600) / 60);
  // const seconds = differenceSeconds % 60;

  // Format the result
  const result = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;

  return result;
}

export const timeFormat = (time) => {
  if (!time) return "00:00";

  const splitedTime = time.split(":");

  if (splitedTime && splitedTime.length > 1)
    return `${splitedTime[0]}:${splitedTime[1]}`;

  return "00:00";
};

export const isFutureDate = (date: string) => {
  if (date === undefined) return false;
  const today = getDateOnly(new Date());
  const dateToValidate = getDateOnly(date);
  return dateToValidate > today;
}
